import { CreateGMWTask, EditGMWTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

/**
 * Schema for Electrode within a Geo-ohm cable
 */
export const electrodeSchema = {
  type: "array",
  title: "Elektroden",
  items: {
    type: "object",
    title: "Elektrode",
    required: [
      "electrodeNumber",
      "electrodePackingMaterial",
      "electrodeStatus",
      "electrodePosition",
    ],
    properties: pickGmwLibraryFields([
      "electrodeNumber",
      "electrodePackingMaterial",
      "electrodeStatus",
      "electrodePosition",
    ]),
  },
} satisfies SchemaForFormData<
  (
    | CreateGMWTask
    | EditGMWTask
  )["sourcedocumentData"]["monitoringTubes"][number]["geoOhmCables"][number]["electrodes"]
>;
